import React, { Component } from 'react';
import MainSettingContext from './MainSettingContext';
import './App.css';
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { t } from './i18n';
class App extends Component {
    static contextType = MainSettingContext;
    get lang() { return localStorage.getItem('lang') || 'th'; }

    constructor(props) {
        super(props)
        this.state = {
            loginStep: 1,
            username: "",
            password: "",
            loginstate: false,
            linelink: "",
            userid: null,
            firstname: null,
            lastname: null,
            point: 0,
            balance: 0,
        }
        this.login = this.login.bind(this);
    }
    login = (e) => {
        if (e) e.preventDefault();
        this.validateLoginForm();
    }
    nextStep = (e) => {
        if (e) e.preventDefault();
        if (!this.state.username || this.state.username.trim() === "") {
            Swal.fire({ title: t(this.lang, 'ln_alert'), text: t(this.lang, 'ln_enter_user'), icon: 'warning', confirmButtonText: t(this.lang, 'ok') });
            return;
        }
        this.setState({ loginStep: 2 });
    }
    backStep = (e) => {
        if (e) e.preventDefault();
        this.setState({ loginStep: 1 });
    }
    validateLoginForm = async (e) => {
        const { username, password } = this.state;
        instance.post("/api/v1/userlogin", {
            userid: username,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
        })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.status === 200) {
                        localStorage.setItem('auth_token', res.data.token)
                        localStorage.removeItem('cookie', '')
                        this.setState({
                            userid: res.data.message.member_id,
                            username: res.data.message.playerid,
                            firstname: res.data.message.firstname,
                            lastname: res.data.message.lastname,
                            point: res.data.message.Point,
                            balance: res.databalance,
                            loginstate: true,
                        });
                        window.location.reload(false);
                    }
                    else if (res.data.status === 401) {
                        Swal.fire({ title: 'error!', text: t(this.lang, 'ln_wrong_cred'), icon: 'error', confirmButtonText: t(this.lang, 'ok') })
                    }
                    else {
                        Swal.fire({ title: 'error!', text: t(this.lang, 'ln_wrong_cred'), icon: 'error', confirmButtonText: t(this.lang, 'ok') })
                    }
                }
                else {
                    this.setState({ firstname: null, lastname: null, point: null, loginstate: false });
                }
            });
    }
    async componentDidMount() {
        try {
            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    this.setState({ linelink: datas[1].value });
                }
            });
        }
        catch (error) {
        }
    }
    onChange = event => {
        let nam, val;
        if (event.target.name === undefined) { nam = event.name; val = event.value; }
        else { nam = event.target.name; val = event.target.value; }
        this.setState({ [nam]: val });
    };

    render() {
        const { loginStep, username, password } = this.state;
        const lang = this.lang;
        return (
            <div className="x-modal-separator-container x-login-form">
                {loginStep === 1 ? (
                    <div className="x-modal-body-base -v3 -phone-number x-form-register-v3">
                        <div className="row -register-container-wrapper -password-body">
                            <div className="col">
                                <div className="x-title-register-modal-v3 ">
                                    <span className="-title">{t(lang, 'ln_user_title')}</span>
                                    <span className="-sub-title">{t(lang, 'ln_user_sub')}</span>
                                </div>
                            </div>
                            <div data-animatable="fadeInRegister" className="col animated fadeInRegister">
                                <div className="-fake-inner-body">
                                    <form onSubmit={this.nextStep}>
                                        <div className="-x-input-icon input-group text-center">
                                            <input type="text" autoComplete="off" id="username" name="username" value={username || ""} onChange={this.onChange} placeholder="username / 0988888888" className="form-control x-form-control -username" autoFocus />
                                        </div>
                                        <div className="-btn-inline-wrapper text-center">
                                            
                                            <button type="button" onClick={this.nextStep} className="btn btn-primary -submit"><span>{t(lang, 'ln_next')}</span></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="x-modal-body-base -v3 -password x-form-register-v3">
                        <div className="row -register-container-wrapper">
                            <div className="col">
                                <div className="x-title-register-modal-v3 ">
                                    <span className="-title">{t(lang, 'ln_pass_title')}</span>
                                    <span className="-sub-title">{t(lang, 'ln_pass_sub')} <span className="-highlight">{username}</span></span>
                                </div>
                            </div>
                            <div data-animatable="fadeInRegister" className="col animated fadeInRegister">
                                <div className="x-modal-separator-container x-form-register">
                                    <div className="-top ">
                                        <form onSubmit={this.login}>
                                            <div className="-x-input-icon mb-3 flex-column">
                                                <input type="password" id="password" name="password" value={password || ""} onChange={this.onChange} className="form-control x-form-control" placeholder={t(lang, 'ln_pass_title')} autoFocus />
                                            </div>
                                            <div className="x-reset-pw-text-container">
                                                <a href="#resetPassword" data-dismiss="modal" data-toggle="modal" data-target="#resetPasswordModal"><u>{t(lang, 'forgot_password')}</u></a>
                                            </div>
                                            <div className="-btn-inline-wrapper text-center">
                                                <button type="button" onClick={this.backStep} className="btn -close btn-secondary mr-2"><span>{t(lang, 'ln_back')}</span></button>
                                                <button type="button" onClick={this.login} className="btn btn-primary -submit"><span>{t(lang, 'login_btn')}</span></button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="-bottom ">
                    <div data-animatable="fadeInModal">
                        <div className="x-admin-contact ">
                            <span className="x-text-with-link-component">
                                <label className="-text-message ">{t(lang, 'ln_problem')}</label>
                                <a href={this.state.linelink} className="-link-message " target="_blank" rel="noopener noreferrer"><u>{t(lang, 'ln_contact_cs')}</u></a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default App;
